import { useIonModal } from "@ionic/react";

import ReportIssueModal from "./ReportIssueModal";
import { UseReportIssueProps } from "./types";

export const useReportIssueModal = (props: UseReportIssueProps) => {
  const { subName, subId, intervals, requestId, status, initialState, school } = props;
  const extraProps: UseReportIssueProps = {
    status,
    initialState,
    subName,
    subId,
    intervals,
    requestId,
    school,
  };

  const [presentModal, dismissModal] = useIonModal(ReportIssueModal, {
    extraProps,
    onDismiss: () => dismissModal(),
  });

  return { presentModal };
};
